/** 道具下发状态：与列表筛选 useFilterHeader 共用 */
export interface ShipStatusOption {
  label: string
  value: string | null
}

export const shipStatusList: ShipStatusOption[] = [
  { label: '全部', value: null },
  { label: '未下发', value: '0' },
  { label: '已下发', value: '10' },
  { label: '待复送', value: '11' },
  { label: '已回收', value: '12' },
]

export function formatShipStatus(val: unknown): string {
  if (val === null || val === undefined || val === '') return '--'
  const s = String(val)
  const found = shipStatusList.find((i) => i.value !== null && String(i.value) === s)
  return found?.label ?? s
}
